import SectionalWritebackRebrand from '@/assets/image/sectional-writeback/sectional-writeback-illustration-rebrand.png';
import Image, { type ImageProps } from 'next/image';

export const SectionalWritebackIllustration = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'sectional writeback', ...rest } = props;

  return <Image src={SectionalWritebackRebrand} alt={alt} {...rest} />;
};
